// extracted by mini-css-extract-plugin
export default {"container":"-naeB","header":"BqL2-","loadingText":"t6lvh","ovalPosition":"q7YQ2","ovalAnimation":"NuP-z","svgOval":"ggGwm","skeleton-progress":"BgE5S","rotate":"vI-n5"};